import styled from 'styled-components'

export const FeatureIconContainer = styled.div`
  img {
    width: 45px;
    height: 45px;
  }

  margin-bottom: 1rem;
`
